import { abra } from "@/constants/artists/abra";
import { adah } from "@/constants/artists/adah";
import { adam } from "@/constants/artists/adam";
import { adan } from "@/constants/artists/adan";
import { adrian } from "@/constants/artists/adrian";
import { adriana } from "@/constants/artists/adriana";
import { aisha } from "@/constants/artists/aisha";
import { alex } from "@/constants/artists/alex";
import { alfonse } from "@/constants/artists/alfonse";
import { alicia } from "@/constants/artists/alicia";
import { alma } from "@/constants/artists/alma";
import { alyssa } from "@/constants/artists/alyssa";
import { amanda } from "@/constants/artists/amanda";
import { amari } from "@/constants/artists/amari";
import { amina } from "@/constants/artists/amina";
import { amy } from "@/constants/artists/amy";
import { anabel } from "@/constants/artists/anabel";
import { andre } from "@/constants/artists/andre";
import { andrew } from "@/constants/artists/andrew";
import { angela } from "@/constants/artists/angela";
import { anna } from "@/constants/artists/anna";
import { antonio } from "@/constants/artists/antonio";
import { arabella } from "@/constants/artists/arabella";
import { ariel } from "@/constants/artists/ariel";
import { arthur } from "@/constants/artists/arthur";
import { asher } from "@/constants/artists/asher";
import { aston } from "@/constants/artists/aston";
import { audra } from "@/constants/artists/audra";
import { austin } from "@/constants/artists/austin";
import { ava } from "@/constants/artists/ava";
import { ayhan } from "@/constants/artists/ayhan";
import { aylin } from "@/constants/artists/aylin";
import { barbara } from "@/constants/artists/barbara";
import { becky } from "@/constants/artists/becky";
import { blair } from "@/constants/artists/blair";
import { blake } from "@/constants/artists/blake";
import { blanca } from "@/constants/artists/blanca";
import { bobo } from "@/constants/artists/bobo";
import { bonnie } from "@/constants/artists/bonnie";
import { boone } from "@/constants/artists/boone";
import { brandon } from "@/constants/artists/brandon";
import { bruna } from "@/constants/artists/bruna";
import { caesar } from "@/constants/artists/caesar";
import { cal } from "@/constants/artists/cal";
import { cameron } from "@/constants/artists/cameron";
import { cammie } from "@/constants/artists/cammie";
import { candace } from "@/constants/artists/candace";
import { carmen } from "@/constants/artists/carmen";
import { chiara } from "@/constants/artists/chiara";
import { chris } from "@/constants/artists/chris";
import { clay } from "@/constants/artists/clay";
import { cleo } from "@/constants/artists/cleo";
import { clifton } from "@/constants/artists/clifton";
import { collin } from "@/constants/artists/collin";
import { dante } from "@/constants/artists/dante";
import { dasha } from "@/constants/artists/dasha";
import { david } from "@/constants/artists/david";
import { debra } from "@/constants/artists/debra";
import { defne } from "@/constants/artists/defne";
import { demi } from "@/constants/artists/demi";
import { dennis } from "@/constants/artists/dennis";
import { denzel } from "@/constants/artists/denzel";
import { deva } from "@/constants/artists/deva";
import { diana } from "@/constants/artists/diana";
import { drayton } from "@/constants/artists/drayton";
import { dustin } from "@/constants/artists/dustin";
import { edgar } from "@/constants/artists/edgar";
import { edwin } from "@/constants/artists/edwin";
import { eleanor } from "@/constants/artists/eleanor";
import { elias } from "@/constants/artists/elias";
import { ellie } from "@/constants/artists/ellie";
import { elliot } from "@/constants/artists/elliot";
import { emilia } from "@/constants/artists/emilia";
import { emilio } from "@/constants/artists/emilio";
import { emma } from "@/constants/artists/emma";
import { emmanuel } from "@/constants/artists/emmanuel";
import { eric } from "@/constants/artists/eric";
import { esther } from "@/constants/artists/esther";
import { ethan } from "@/constants/artists/ethan";
import { evan } from "@/constants/artists/evan";
import { ezike } from "@/constants/artists/ezike";
import { fabian } from "@/constants/artists/fabian";
import { felicia } from "@/constants/artists/felicia";
import { fenrir } from "@/constants/artists/fenrir";
import { fiona } from "@/constants/artists/fiona";
import { florence } from "@/constants/artists/florence";
import { frank } from "@/constants/artists/frank";
import { freddie } from "@/constants/artists/freddie";
import { freya } from "@/constants/artists/freya";
import { frida } from "@/constants/artists/frida";
import { friedrich } from "@/constants/artists/friedrich";
import { gabriel } from "@/constants/artists/gabriel";
import { gemma } from "@/constants/artists/gemma";
import { george } from "@/constants/artists/george";
import { gerald } from "@/constants/artists/gerald";
import { gladys } from "@/constants/artists/gladys";
import { gracie } from "@/constants/artists/gracie";
import { hailey } from "@/constants/artists/hailey";
import { hana } from "@/constants/artists/hana";
import { harold } from "@/constants/artists/harold";
import { henao } from "@/constants/artists/henao";
import { henry } from "@/constants/artists/henry";
import { hobbes } from "@/constants/artists/hobbes";
import { india } from "@/constants/artists/india";
import { isaac } from "@/constants/artists/Isaac";
import { isabella } from "@/constants/artists/isabella";
import { jack } from "@/constants/artists/jack";
import { jackie } from "@/constants/artists/jackie";
import { jacob } from "@/constants/artists/jacob";
import { jade } from "@/constants/artists/jade";
import { jake } from "@/constants/artists/jake";
import { jamal } from "@/constants/artists/jamal";
import { james } from "@/constants/artists/james";
import { jasper } from "@/constants/artists/jasper";
import { jeffrey } from "@/constants/artists/jeffrey";
import { jermaine } from "@/constants/artists/jermaine";
import { joachim } from "@/constants/artists/joachim";
import { joey } from "@/constants/artists/joey";
import { john } from "@/constants/artists/john";
import { jordan } from "@/constants/artists/jordan";
import { josephin } from "@/constants/artists/josephin";
import { josh } from "@/constants/artists/josh";
import { jules } from "@/constants/artists/jules";
import { julian } from "@/constants/artists/julian";
import { julius } from "@/constants/artists/julius";
import { june } from "@/constants/artists/june";
import { kaden } from "@/constants/artists/kaden";
import { karl } from "@/constants/artists/karl";
import { keidran } from "@/constants/artists/keidran";
import { khadra } from "@/constants/artists/khadra";
import { lauryn } from "@/constants/artists/lauryn";
import { leo } from "@/constants/artists/leo";
import { leondra } from "@/constants/artists/leondra";
import { leyla } from "@/constants/artists/leyla";
import { lily } from "@/constants/artists/lily";
import { ludovica } from "@/constants/artists/ludovica";
import { luke } from "@/constants/artists/luke";
import { maddy } from "@/constants/artists/maddy";
import { madelyn } from "@/constants/artists/madelyn";
import { marcus } from "@/constants/artists/marcus";
import { margaery } from "@/constants/artists/margaery";
import { mario } from "@/constants/artists/mario";
import { mark } from "@/constants/artists/mark";
import { martin } from "@/constants/artists/martin";
import { mary } from "@/constants/artists/mary";
import { maryam } from "@/constants/artists/maryam";
import { mason } from "@/constants/artists/mason";
import { maxine } from "@/constants/artists/maxine";
import { maya } from "@/constants/artists/maya";
import { mia } from "@/constants/artists/mia";
import { micah } from "@/constants/artists/micah";
import { michael } from "@/constants/artists/michael";
import { miguel } from "@/constants/artists/miguel";
import { mika } from "@/constants/artists/mika";
import { mike } from "@/constants/artists/mike";
import { milo } from "@/constants/artists/milo";
import { murray } from "@/constants/artists/murray";
import { nadia } from "@/constants/artists/nadia";
import { nara } from "@/constants/artists/nara";
import { neoma } from "@/constants/artists/neoma";
import { nessa } from "@/constants/artists/nessa";
import { nia } from "@/constants/artists/nia";
import { nicole } from "@/constants/artists/nicole";
import { niel } from "@/constants/artists/niel";
import { noah } from "@/constants/artists/noah";
import { nora } from "@/constants/artists/nora";
import { omi } from "@/constants/artists/omi";
import { paul } from "@/constants/artists/paul";
import { peggy } from "@/constants/artists/peggy";
import { rae } from "@/constants/artists/rae";
import { ragnar } from "@/constants/artists/ragnar";
import { ralph } from "@/constants/artists/ralph";
import { ramiro } from "@/constants/artists/ramiro";
import { raphael } from "@/constants/artists/raphael";
import { ray } from "@/constants/artists/ray";
import { rebecca } from "@/constants/artists/rebecca";
import { rhea } from "@/constants/artists/rhea";
import { rico } from "@/constants/artists/rico";
import { robin } from "@/constants/artists/robin";
import { roman } from "@/constants/artists/roman";
import { sabrina } from "@/constants/artists/sabrina";
import { sam } from "@/constants/artists/sam";
import { samantha } from "@/constants/artists/samantha";
import { sarah } from "@/constants/artists/sarah";
import { sasha } from "@/constants/artists/sasha";
import { sebastian } from "@/constants/artists/sebastian";
import { sierra } from "@/constants/artists/sierra";
import { skarre } from "@/constants/artists/skarre";
import { stacey } from "@/constants/artists/stacey";
import { stellan } from "@/constants/artists/stellan";
import { stuart } from "@/constants/artists/stuart";
import { summer } from "@/constants/artists/summer";
import { tamia } from "@/constants/artists/tamia";
import { tess } from "@/constants/artists/tess";
import { thengil } from "@/constants/artists/thengil";
import { theodore } from "@/constants/artists/theodore";
import { therese } from "@/constants/artists/therese";
import { thomas } from "@/constants/artists/thomas";
import { thora } from "@/constants/artists/thora";
import { tina } from "@/constants/artists/tina";
import { tito } from "@/constants/artists/tito";
import { tom } from "@/constants/artists/tom";
import { tracy } from "@/constants/artists/tracy";
import { travis } from "@/constants/artists/travis";
import { tyler } from "@/constants/artists/tyler";
import { tyra } from "@/constants/artists/tyra";
import { valerie } from "@/constants/artists/valerie";
import { vanessa } from "@/constants/artists/vanessa";
import { wesley } from "@/constants/artists/wesley";
import { william } from "@/constants/artists/william";
import { yara } from "@/constants/artists/yara";
import { yemi } from "@/constants/artists/yemi";
import { zachary } from "@/constants/artists/zachary";
import { zaria } from "@/constants/artists/zaria";
import { zayn } from "@/constants/artists/zayn";
import { zion } from "@/constants/artists/zion";
import { Artist } from "@/types/types";

export const artists: Artist[] = [
  mark,
  blake,
  nicole,
  hailey,
  mike,
  ava,
  amina,
  josh,
  thomas,
  felicia,
  marcus,
  yara,
  noah,
  theodore,
  lily,
  alyssa,
  chiara,
  stuart,
  debra,
  andrew,
  gladys,
  hana,
  karl,
  sam,
  stellan,
  leo,
  julian,
  leondra,
  dante,
  amy,
  khadra,
  edgar,
  tamia,
  jack,
  aylin,
  jeffrey,
  julius,
  adam,
  milo,
  vanessa,
  roman,
  florence,
  david,
  maxine,
  elliot,
  zaria,
  blair,
  zion,
  emma,
  neoma,
  candace,
  thora,
  mika,
  eleanor,
  george,
  nara,
  jake,
  arthur,
  sarah,
  cal,
  gemma,
  alfonse,
  defne,
  barbara,
  joachim,
  ray,
  skarre,
  asher,
  ludovica,
  thengil,
  alicia,
  frank,
  blanca,
  alex,
  keidran,
  audra,
  june,
  abra,
  bruna,
  gerald,
  summer,
  gracie,
  emilia,
  lauryn,
  samantha,
  rhea,
  fiona,
  leyla,
  rico,
  dennis,
  drayton,
  freddie,
  jade,
  adan,
  harold,
  deva,
  ramiro,
  frida,
  micah,
  amari,
  maddy,
  hobbes,
  dasha,
  eric,
  antonio,
  murray,
  anna,
  elias,
  maya,
  isaac,
  boone,
  nessa,
  jules,
  ezike,
  emilio,
  martin,
  carmen,
  ellie,
  anabel,
  paul,
  madelyn,
  peggy,
  ayhan,
  margaery,
  tina,
  adrian,
  william,
  tito,
  mario,
  brandon,
  miguel,
  john,
  clifton,
  bobo,
  aisha,
  amanda,
  emmanuel,
  tracy,
  clay,
  alma,
  jamal,
  freya,
  nadia,
  therese,
  joey,
  tyra,
  andre,
  adah,
  jasper,
  bonnie,
  caesar,
  henry,
  gabriel,
  ralph,
  india,
  nora,
  wesley,
  jordan,
  zachary,
  rebecca,
  cameron,
  maryam,
  edwin,
  denzel,
  jermaine,
  jacob,
  arabella,
  tyler,
  friedrich,
  evan,
  omi,
  josephin,
  becky,
  sierra,
  luke,
  esther,
  kaden,
  fabian,
  mia,
  travis,
  tom,
  chris,
  fenrir,
  michael,
  tess,
  mary,
  robin,
  aston,
  nia,
  james,
  jackie,
  valerie,
  raphael,
  adriana,
  rae,
  stacey,
  collin,
  diana,
  henao,
  yemi,
  cleo,
  zayn,
  isabella,
  cammie,
  dustin,
  mason,
  sabrina,
  niel,
  ariel,
  ragnar,
  demi,
  angela,
  ethan,
  sebastian,
  austin,
  sasha,
];
